<template>
    <aside class="fixed z-20 inset-0 bg-background bg-opacity-75 flex justify-center items-center">
        <div class="relative m-4 px-16 h-96 sm:w-2/3 lg:w-2/5 max-w-[765px] flex justify-center items-center bg-cloud text-center">
            <button
                type="button"
                aria-label="Close Modal"
                @click="emitCloseEvent"
                class="absolute top-3 right-3"
            >
                <img
                    src="@/assets/icons/close.svg"
                    alt="Close Icon"
                    width="14"
                    height="14"
                >
            </button>

            <div>
                <h1 class="mb-2 text-3xl font-freizeit">
                    {{ titleText }}
                </h1>

                <p class="mb-6 text-xs font-grotesk">
                    {{ copyText }}
                </p>

                <div class="flex flex-col items-center gap-1 font-freizeit">
                    <base-button
                        @click="emitCloseEvent"
                        radius="rounded"
                        class="px-5 w-32 text-base"
                    >
                        {{ $t('CANCEL') }}
                    </base-button>

                    <button
                        @click="emitConfirmEvent"
                        type="button"
                        class="px-5 py-2 text-base"
                    >
                        {{ $t('CONFIRM') }}
                    </button>
                </div>
            </div>
        </div>
    </aside>
</template>

<script>
    import BaseButton from './BaseButton.vue';

    export default {
        components: {
            BaseButton,
        },

        props: {
            titleText: {
                type: String,
                required: true,
            },
            copyText: {
                type: String,
                required: true,
            },
        },

        methods: {
            emitCloseEvent() {
                this.$emit('closeModal');
            },

            emitConfirmEvent() {
                this.$emit('confirmModal');
            },
        },
    };
</script>
